export const faqs = [
  {
    id: "1",
    header: "Q1: What does GBT stand for?",
    body: "GBT is stand for Grand Block Technologies.",
  },
  {
    id: "2",
    header: "Q2: What kind of company is GBT Solutions?",
    body: "GBT Solutions is an end-to-end solutions and integrated service management organization. We offer comprehensive services across the entire spectrum of ICT products and software solutions.",
  },
  {
    id: "3",
    header: "Q3: What types of services do you offer?",
    body: "We offer a wide range of services, including:, \n ICT solutions design and implementation., \n Managed service provider (MSP) services., \n Software licensing and deployment., \n Software Development., \n Security solutions., \n Cloud computing services., \n Network and infrastructure management Data center services., \n IT consulting. ,",
  },
  {
    id: "4",
    header: "Q4: What industries do you serve?",
    body: "We serve a diverse range of industries, including:, \n Finance, \n Healthcare, \n Government, \n Education, \n Retail, \n Manufacturing, \n Technology. , \n",
  },
  {
    id: "5",
    header: "Q5: What are the benefits of using GBT Solutions?",
    body: "We offer a number of benefits,including:, \n Increased productivity and efficiency., \n Enhanced reliability and security., \n Reduced costs., \n Improved scalability and flexibility., \n Access to expert IT professionals 24/7 support., \n",
  },
  {
    id: "6",
    header:
      "Q6: How do you achieve higher levels of productivity and efficiency?",
    body: "We implement strategic solutions and follow proven global delivery standards. We also focus on automation and streamlining processes.",
  },
  {
    id: "7",
    header: "Q7: How do you ensure reliability and security?",
    body: "We have a robust infrastructure and implement industry-leading security measures to protect your data and systems.",
  },
  {
    id: "8",
    header: "Q8: How can you help me reduce my IT costs?",
    body: "We can help you optimize your IT spend by offering cost-effective solutions and services. We can also help you avoid unnecessary technology investments.",
  },
  {
    id: "9",
    header: "Q9: Do you have any partners?",
    body: " Yes, we partner with a number of leading technology vendors and service providers. This allows us to offer you the best possible solutions and services.",
  },
  {
    id: "10",
    header: "Q10: Do you offer training and support?",
    body: "Yes, we offer comprehensive training and support services to ensure you get the most out of our solutions.",
  },
  {
    id: "11",
    header: "Q11: What are your terms of service?",
    body: "Please visit our terms of service Page.",
  },
];
